
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card } from '../../ui';

import HogarWrapper from './Hogar.style';
import Steps from '../../Steps';
import { setStepsList } from "../../../actions";
import { options } from "../../../operations";

import HogarForm_1 from './HogarForm_1';
import HogarForm_2 from './HogarForm_2';
import HogarForm_3 from './HogarForm_3';
import HogarForm_4 from './HogarForm_4';
import Quotation from './Quotation';
import Login from '../../Common/Login';
import HogarForm_5 from './HogarForm_5';
import ClientData from '../../Common/Client/ClientData';
import Payment from './Payment';

class Hogar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      globalSteps1: ['1. Datos básicos', '2. Estructura', '3. Cotización'],
      globalSteps2: ['1. Datos del inmueble', '2. Tus datos', '3. Información de pago'],
      steps: [
        { pos: 0, global:  0, name: 'hogarForm_1', backButton: false },
        { pos: 1, global:  0, name: 'hogarForm_2' },
        { pos: 2, global:  1, name: 'hogarForm_3' },
        { pos: 3, global:  1, name: 'hogarForm_4' },
        { pos: 4, global:  2, name: 'quotation' },
        { pos: 5, global: -1, name: 'login' },
        { pos: 6, global:  0, name: 'hogarForm_5' },
        { pos: 7, global:  1, name: 'clientData' },
        { pos: 8, global:  2, name: 'payment' },
      ]
    };
  }

  componentDidMount() {
    const { steps } = this.state;
    const { setStepsList, getDatosHogar } = this.props;
    setStepsList(steps);
    getDatosHogar();
  }

  getStepContent() {
    const { selectedStep } = this.props;
    switch (selectedStep.name) {
      case 'hogarForm_1': return <HogarForm_1 />;
      case 'hogarForm_2': return <HogarForm_2 />;
      case 'hogarForm_3': return <HogarForm_3 />;
      case 'hogarForm_4': return <HogarForm_4 />;
      case 'quotation':   return <Quotation />;
      case 'login':       return <Login />;
      case 'hogarForm_5': return <HogarForm_5 />;
      case 'clientData':  return <ClientData />;
      case 'payment':     return <Payment />;
    }
  }

  render() {
    const { globalSteps1, globalSteps2 } = this.state;
    const { selectedStep } = this.props;
    return (
      <Card className="Card--medium">
        <HogarWrapper>
          <Steps globalSteps={selectedStep.pos < 5 ? globalSteps1 : globalSteps2} />
          <div>
            {this.getStepContent()}
          </div>
        </HogarWrapper>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    },
    getDatosHogar: () => {
      dispatch(options.getFireOptions());
      dispatch(options.getTheftOptions());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Hogar);